export type LoginType = 'remote' | 'local'

export const getAuthScheme = (loginType: LoginType) =>
  loginType === 'remote' ? 'BearerA' : 'Bearer'
